import type { SVGProps } from 'react';

export const ArrowHeadIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M15.138 9C16.2408 9 16.8996 10.1191 16.2315 10.9251L14.8804 12.5548C14.8725 12.5643 14.8642 12.5743 14.8557 12.5834L13.0086 14.5631C12.4627 15.1481 11.4513 15.1453 10.9103 14.5565L9.09522 12.5793C9.08545 12.5687 9.07586 12.5579 9.0669 12.5467L7.75512 10.9087C7.10821 10.1007 7.76979 9.0002 8.86227 9H15.138Z" />
  </svg>
);
